// import {setCookie} from '../common/cookie';
import axios from 'axios';
import { getCookie } from './cookie';

export const Api = {

    baseUrl: process.env.REACT_APP_API_URL,
    pcUrl: process.env.REACT_APP_PC_URL,
    cartUrl: process.env.REACT_APP_CART_URL,
    api2Url: process.env.REACT_APP_API2_URL,

    getMallInfo:function(mall_name){
        let _url = this.baseUrl+'/front/v2/minishop/view/?mall_web_user='+mall_name;
        return axios.get(_url);
    },

    getUserInfo:function(){
        let _url = this.baseUrl+'/front/v2/user/info'
        const auth_token = getCookie('auth_token')
        let config = {
            withCredentials: true,
            xsrfHeaderName: 'Authorization'
        }

        return axios.post(_url, {auth_token}, config)
    },

    addEstimate:function(params){
        let _url = this.baseUrl+"/front/v2/estimate/save/";
        return axios.post(_url, params);
    },

    getCategorys:function(shopNO){
        let _url = this.baseUrl+"/front/v2/item/cate/";
        if (shopNO) _url += '?idx_b_manager='+shopNO

        return axios.get(_url).then(responce=>{
            return responce
        });
    },

    getTalkEstimate:function(talk_id){
        let _url = this.baseUrl+"/front/v1/estimate/talk?talk_id="+talk_id;
        return axios.get(_url);
    },

    getHotdeal:function(cate){
        // let _url = this.baseUrl+"/front/v1/event/hotdeal/"+cate
        let _url = this.baseUrl+"/front/v2/deal/list/"+cate
        return axios.get(_url);
    },

    getMinishop:function(cate_id, item_id){
        let _url = this.baseUrl+"/front/v1/item/getMinishop/?cate_id="+cate_id+"&item_id="+item_id+"&stdpcYN=N"
        return axios.get(_url);
    },

    getItems:function(params) {
        const _url = this.baseUrl+"/front/v2/items"
        // $fields = ['stdpc', "maker", "hotdeal"];
        params.fields = "stdpc,maker,hotdeal";
        return axios.get(_url, {params});
    },

    getItemsParam:function(params, body){
        // cate, nowpage, pagecount, sortkey, price_type, body, shopID
        let getParams = []
        // if (!params.cate) return false;

        if (params.nowpage) getParams.push('nowpage='+params.nowpage)
        else getParams.push('nowpage=1')

        if (params.pagecount) getParams.push('pagecount='+params.pagecount)
        else getParams.push('pagecount=10')

        if (params.totalcount) getParams.push('totalcount='+params.totalcount)
        else getParams.push('totalcount=0')

        if (params.sortkey) getParams.push('sortkey='+params.sortkey)
        else getParams.push('sortkey=1')

        if (params.price_type) getParams.push('price_type='+params.price_type)
        else getParams.push('price_type=cash')

        if (params.idx_b_manager) getParams.push('idx_b_manager='+params.idx_b_manager)
        else getParams.push('idx_b_manager=1')

        if (params.sale) getParams.push('sale='+params.sale)
        else getParams.push('sale=N')

        // store가 있을경우 idx_b_manager은 무시됨
        if (params.store) getParams.push('store='+params.store)

        if (params.adv) getParams.push('adv='+params.adv)
        let _url = this.baseUrl+"/front/v1/item/list/"
        if (params.cate) _url = _url+params.cate+'/'
        _url = _url+"?"+getParams.join('&');
        return axios.post(_url, body);
    },

    getItemCount:function(cate, body, shopNo){

        let _url = this.baseUrl+"/front/v1/item/listCount/"
        if (cate !== '') _url = _url+cate+'/'
        _url = _url+"?sale=N&price_type=cash";
        if (shopNo) _url = _url+'&idx_b_manager='+shopNo
        else _url = _url+'&idx_b_manager=1'
        return axios.post(_url, body);
    },


    getSpecs:function(cate){
        let _url = this.baseUrl+"/front/v1/item/spec/"+cate;
        return axios.get(_url);
    },


    getStdpcSpecs:function(item_id){
        let _url = this.baseUrl+"/front/v1/stdpc/items/"+item_id;
        return axios.get(_url);
    },

    getPrice:function(cate){
        let _url = this.baseUrl+"/front/v1/item/getSchPrice/?cate_id="+cate;
        return axios.get(_url);
    },

    getEstimateList:function(itemList, type, mallID, stdpc, soldout){
        let mallQuery = '&mallID=1'
        let stdpcQuery = ''
        let cashQuery = 'priceType=cash'
        let includeSoldout = '&includeSoldout=N'
        if (type) cashQuery = 'priceType='+type
        if (mallID) mallQuery = '&mallID='+mallID
        if (stdpc) stdpcQuery = '&stdpcInfoItemID='+stdpc
        if (soldout) includeSoldout = '&includeSoldout='+soldout

        let _url = this.baseUrl
            +"/front/v1/estimate/list?"
            +cashQuery
            +"&itemList="+itemList
            +mallQuery+stdpcQuery+includeSoldout;
        return axios.get(_url);
    },

    getAd:function(code_ad, cate_id){
        let _url = this.baseUrl+"/front/v2/ads/"+code_ad;
        if (cate_id) _url += "/"+cate_id
        return axios.get(_url);
    },

    getAdver:function(cate_id, adtype, idx_b_manager){
        let adType = '?adtype='+adtype
        let b_manager = idx_b_manager && '&idx_b_manager='+idx_b_manager
        let _url = this.baseUrl+"/front/v1/adver/" + cate_id + adType + b_manager;
        return axios.get(_url);
    },

    getCurationAd:function(cate_id){
        let _url = this.baseUrl+"/front/v1/curation/estimate"
        if (cate_id) _url += '/'+cate_id
        return axios.get(_url);
    },

    getEvent:function(cate_id){
        let _url = this.baseUrl+"/front/v1/event/category/"+cate_id;
        return axios.get(_url);
    },

    getMediumGuideNews:function(cate_id, idx_threads){
        let _url = this.baseUrl+"/front/v1/medium/newsReviewView/"+cate_id;
        if (idx_threads) {
            _url = this.baseUrl+"/front/v1/medium/newsReviewView/"+cate_id
            +"?idx_threads="+idx_threads;
        }
        return axios.get(_url);
    },

    getMediumGuide:function(cate_id, idx){
        let _url = this.baseUrl+"/front/v1/medium/view/"+cate_id;
        if (idx !== undefined) _url = _url+'?idx_threads='+idx
        return axios.get(_url);
    },


    getAsideMedium:function(cate_id){
        let _url = this.baseUrl+"/front/v2/common/aside/"+cate_id;
        return axios.get(_url);
    },

    getMediumGuideList:function(cate_id){
        let _url = this.baseUrl+"/front/v1/medium/topList/"+cate_id;
        return axios.get(_url);
    },

    getCurations:function(cate_id, idx_b_manager){
        let _url = this.baseUrl+"/front/v2/curation/"+cate_id;
        if (idx_b_manager !== 1) {
            _url += "/"+idx_b_manager
        }
        return axios.get(_url);
    },

    getCuration:function(cate_id){
        let _url = this.baseUrl+"/front/v1/item/CurationList/"+cate_id;
        return axios.get(_url);
    },

    saveEstimates:function(params){
        // let fd = new FormData(document.getElementById('estimateListForm'));
        var _url = this.baseUrl+'/front/v1/estimate/sheet';
        return axios.post(_url, params);
    },


    addBasket:function(shopNO, userID, itemList){
        let _url = this.baseUrl+'/front/v1/cart/regist/'+shopNO+'/'+userID;

        let items = [];
        for(let i in itemList){
            let row = {};
            row['item_id']     = itemList[i].itemID;
            row['cnt_item']    = itemList[i].count;
            row['f_item']      = 0;
            row['f_route']     = 0;
            row['idx_est_prt'] = 0;

            items.push(row);
        }

        let param = {};
        param.items = items;

        return axios.post(_url,param);
    },

    // 상품개수 수정
    getStdpc: function() {
        let _url = this.baseUrl + '/front/v3/item/cate/201/?f_stdpc=1&f_stdpc_limit=12'
        return axios.get(_url)
    },

    getNoitce:function(b_manager){
        let _url = this.baseUrl+"/front/v2/board/main/notice";
        if (b_manager !== undefined) _url += '/'+b_manager
        return axios.get(_url);
    },

    getGeoCode:function(addr){
        let _url = this.baseUrl+"/front/v2/minishop/geocode?addr="+addr;
        // let _url = "//www.pping.kr/partner/getGeocodeAjax?addr="+addr;

        return axios.get(_url);
    },

    getReviewList:function(b_manager){
        let _url = this.baseUrl+"/common/information/manager/reviews/"+b_manager+"?pageSize=5";
        return axios.get(_url);
    },

    /**
     * 로고 API
     * @param idx_b_manager
     * @param type ad: 광고 (오픈, 럭키쇼핑)
     * @returns {Promise<AxiosResponse<any>>}
     */
    getMarketLogo:function(idx_b_manager, type){
        let _url = `${this.api2Url}/desktop/v1/logo/${idx_b_manager}`;
        if (type !== undefined) {
            _url = `${this.api2Url}/desktop/v1/logo/${idx_b_manager}/${type}`;
        }
        return axios.get(_url);
    },

    /**
     * 장바구니 아이템 확인
     * */
    getBasketCountByMall: function(userID, mallID) {
        const _url = this.baseUrl + '/front/v1/cart/count/' + userID + '/' + mallID
        return axios.get(_url)
    },
    /**
     * 해당 mallID 장바구니 제거
     * */
    removeBasketByMall: function(userID, mallID) {
        const _url = this.baseUrl + '/front/v1/cart/remove/' + mallID + '/' + userID
        return axios.get(_url)
    },
}



// WEBPACK FOOTER //
// ./src/estimate_list/libs/api.js